export default __webpack_public_path__ + "static/media/condorAndino.aa70561a.jpg";